// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34shP","notes":"Notes_notes__3W3X9","note":"Notes_note__3_s-m","markdown":"Notes_markdown__36n0n"};